module.exports = {
    language: {
        name: 'en'
    },
    search:{
        placeholder:'Keywords',
        btn:'Search'
    },
     nav: {
        about:'ABOUT',
        story:'JQ Story Series',
        occupation:'CAREERS',
        positions:'Open Positions',
        careers:'Campus Recruiting',
        product:'PRODUCTS',
        responsibility:'SOCIAL RESPONSIBILITY',
        contact:'CONTACT',
    },
    home:{
        section1:'JQ Investments',
        more:'More Info',
        story:'JQ Story Series',
        storySub:'Into the World of a Quant',
        responsibility:"Social Responsibility",
        occupation:'Join us!',
        occupationSub:'',
    },
    story:{
        banner:'JQ Story Series',
        bannerSub:'Meet our people!',
        moew:'More Info'
    },
     about:{
        about:'ABOUT',
        story:'JQ STORY SERIES',
        stroySub:'Meet our people! We embrace every possibility',
        more:'More Info',
        facts:'FACTS ABOUT JQ',
        work:'LIFE AT JQ'
    },
     responsibility:{
        banner:'Social Responsibility',
        bannerSub:'Creating a better future together!'
    },
    occupation:{
        bannerTxt:'JQ Investments, Embrace Every Possibility!',
        findJod:'More Info',
        openPosition:'OPEN POSITIONS',
        schoolTxt:'CAMPUS EVENTS',
        more:'More Info',
        activity:'Campus events',
        school:'2022 CAMPUS RECRUITING',
        schoolSub:'',
        winnerCap:'JQ WINTER CAMP',
        winnerCapSub:'',
        hope:'Coming soon',
        jiayouzhan:'Interview Tips',
    },
    code:{
        welcome:'Get more information via',
        jiaqi:'',
        contact:'JQ Talent Partner',
        send:'or contact us at',
    },
     socialPost:{
        banner:'OPEN POSITIONS',
        look:'',
        placeholder:'Please select'
    },
    socialDetail:{
        title:'Open Positions',
        introduce:'Job description',
        requetion:'Job requirements',
        location:'Location',
        send:'Apply Now, please send your resume and desired position to careers@jqinvestments.com.',
        format:'',
        submit:'Apply Now',
        tip1:'To apply, please send us an email at ',
        tip2:'Please include your resume, the position(s) in which you are interested, location preference, and whether you are looking for a full-time position or a summer internship.',
        tip3:'',
        mode:'Application',
    },
    productIndex:{
        userName:'用户名',
        userNamePlaceholder:'请输入用户名',
        userNameFindPlaceholder:'请输入你要找回的用户名',
        password:'密码',
        passwordPlaceholder:'请输入密码',
        loginNow:'立即登录',
        forget:'忘记密码',
        bindEmail:'绑定邮箱',
        bindEmailPlaceholder:'请输入绑定邮箱地址',
        bindPhone:'绑定手机',
        bindPhonePlaceholder:'请输入绑定手机号码',
        sendEmail:'发送邮件',
        phone:'手机',
        phonePlaceholder:'请输入手机号码',
        code:'验证码',
        codePlaceholder:'验证码',
        sendCode:'发送验证码',
        newPassword:'新密码',
        newPasswordPlaceholder:'请输入新密码',
        confirmPassword:'修改密码',
        confrimAgain:'请再次输入新密码',
        agreement:'合格投资者认定',
        userLogin:'用户登录',
        findPhone:'通过绑定手机号码找回',
        findEmail:'通过绑定邮箱找回',
    },
    productList:{
        bannerTxt:'佳期旗下产品',
    },
    contact:{
        china:'BEIJING',
        shanghai:'SHANGHAI'
    },
    questionnaire:{
        title:'Questionnaire investigation',
        subTitle:'Thank you for your submission',
        placeholder:'Please choose the type of questionnaire and answer the question',
        submit:'Submit',
        result:'Questionnaire results',
        tip:'Your questionnaire has been submitted. Thank you for your participation.'
    },
    privacyPolicy:{
        agreement:'Privacy policy',
        determine:'OK'
    }
}